/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Page_Prize_TreeInputs */

const en_invite_page_prize_tree = /** @type {(inputs: Invite_Page_Prize_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pineapple Tree House`)
};

const ar_invite_page_prize_tree = /** @type {(inputs: Invite_Page_Prize_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منزل شجرة الأناناس`)
};

const de_invite_page_prize_tree = /** @type {(inputs: Invite_Page_Prize_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ananasbaumhaus`)
};

const es_invite_page_prize_tree = /** @type {(inputs: Invite_Page_Prize_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Casa de piña`)
};

const fr_invite_page_prize_tree = /** @type {(inputs: Invite_Page_Prize_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maison d'Ananas`)
};

const it_invite_page_prize_tree = /** @type {(inputs: Invite_Page_Prize_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Casetta dell'Ananas`)
};

const ja_invite_page_prize_tree = /** @type {(inputs: Invite_Page_Prize_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パイナップルの木ハウス`)
};

const ko_invite_page_prize_tree = /** @type {(inputs: Invite_Page_Prize_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`파인애플 집`)
};

const pt_br_invite_page_prize_tree = /** @type {(inputs: Invite_Page_Prize_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Casa Árvore de Abacaxi`)
};

const ru_invite_page_prize_tree = /** @type {(inputs: Invite_Page_Prize_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дом на дереве ананаса`)
};

const th_invite_page_prize_tree = /** @type {(inputs: Invite_Page_Prize_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บ้านต้นสับปะรด`)
};

const tr_invite_page_prize_tree = /** @type {(inputs: Invite_Page_Prize_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ananas Ağaç Evi`)
};

const zh_cn_invite_page_prize_tree = /** @type {(inputs: Invite_Page_Prize_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`凤梨树屋`)
};

const zh_tw_invite_page_prize_tree = /** @type {(inputs: Invite_Page_Prize_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`鳳梨樹屋`)
};

/**
* | output |
* | --- |
* | "Pineapple Tree House" |
*
* @param {Invite_Page_Prize_TreeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invite_page_prize_tree = /** @type {((inputs?: Invite_Page_Prize_TreeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Page_Prize_TreeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invite_page_prize_tree(inputs)
	if (locale === "ar") return ar_invite_page_prize_tree(inputs)
	if (locale === "de") return de_invite_page_prize_tree(inputs)
	if (locale === "es") return es_invite_page_prize_tree(inputs)
	if (locale === "fr") return fr_invite_page_prize_tree(inputs)
	if (locale === "it") return it_invite_page_prize_tree(inputs)
	if (locale === "ja") return ja_invite_page_prize_tree(inputs)
	if (locale === "ko") return ko_invite_page_prize_tree(inputs)
	if (locale === "pt_br") return pt_br_invite_page_prize_tree(inputs)
	if (locale === "ru") return ru_invite_page_prize_tree(inputs)
	if (locale === "th") return th_invite_page_prize_tree(inputs)
	if (locale === "tr") return tr_invite_page_prize_tree(inputs)
	if (locale === "zh_cn") return zh_cn_invite_page_prize_tree(inputs)
	return zh_tw_invite_page_prize_tree(inputs)
});